<div class="window-title">
  {{title}}
</div>
